import { render, staticRenderFns } from "./imperialGlory.vue?vue&type=template&id=87ef6b2e"
import script from "./imperialGlory.vue?vue&type=script&lang=js"
export * from "./imperialGlory.vue?vue&type=script&lang=js"
import style0 from "./imperialGlory.vue?vue&type=style&index=0&id=87ef6b2e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports